import { ChannelSettingSectionHeader } from './ChannelSettingSectionHeader';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@frontend/components/ui/select';

export type OverrideValue = 'global' | 'enabled' | 'disabled';

export function ChannelSettingDropdown({
  title,
  description,
  value,
  onValueChange,
  globalEnabled,
  isReadOnly = false,
}: {
  title: string;
  description: string;
  value: OverrideValue;
  onValueChange: (value: OverrideValue) => void;
  globalEnabled: boolean;
  isReadOnly?: boolean;
}) {
  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <ChannelSettingSectionHeader title={title} description={description} />
      </div>

      <Select
        value={value}
        onValueChange={(value) =>
          !isReadOnly && onValueChange(value as OverrideValue)
        }
        disabled={isReadOnly}
      >
        <SelectTrigger size="sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="global">
            Use global setting ({globalEnabled ? 'On' : 'Off'})
          </SelectItem>
          <SelectItem value="enabled">On for this channel</SelectItem>
          <SelectItem value="disabled">Off for this channel</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
